module.exports = __webpack_public_path__ + "img/beers.5eecfa15.svg";